import React, { useState, useRef, useEffect } from "react";
import ReactFlow, {
  useNodesState,
  useEdgesState,
  Controls,
  ReactFlowProvider,
} from "react-flow-renderer";
import WorkflowDAG from "./workflowDAG";
import "./workflows.css";
import { useSelector } from "react-redux";
import { getInitialNodesService } from "../../../services/editor";

const nodeTypes = { workflowDAG: WorkflowDAG };

export default function LineageVisulaizer({ editWorkflow = false, style = {} }) {
  const reactFlowWrapper = useRef(null);
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges] = useEdgesState([]);
  const [, setReactFlowInstance] = useState(null);
  const [, setDagsStatuses] = useState([]);
  const [DAGList] = useState([]);
  const [init, setInit] = useState(true);

  const activeFile = useSelector((state) => state.activeTab);

  const checkActiveFile = (fileName) => {
    const activeFileName = activeFile.split("/");
    const targetFileName = activeFileName[activeFileName.length - 1];

    return (
      `${fileName.substring(fileName.indexOf("_") + 1)}.sql` === targetFileName
    );
  };

  const getInitialNodes = async () => {
    if (!editWorkflow?.initial_workflow_chain || !editWorkflow?.run_id) {
      setInitialNodes();
      return;
    }

    const response = await getInitialNodesService(
      editWorkflow.run_id,
      editWorkflow.workflow_name
    );

    if (response) {
      setInitialNodes(response.data);
      setDagsStatuses(Object.values(response.data).map((item) => item.state));
    } else {
      setInitialNodes();
    }
  };

  const setInitialNodes = (statusesList) => {
    if (editWorkflow.initial_workflow_chain) {
      const starterEdges = [];
      const starterData = [...editWorkflow.initial_workflow_chain].map(
        (node) => {
          console.log("Node inside setInitialNodes");
          console.log(node);
          console.log(node.logo);
          if (node.dependencies.length) {
            node.dependencies.forEach((dep) => {
              starterEdges.push({
                target: node.dag,
                source: dep,
                id: `${node.dag}-${dep}`,
              });
            });
          }
          console.log({
            id: node.dag,
            type: "workflowDAG",
            position: {
              x: node?.position?.x ? parseFloat(node.position.x) : 0,
              y: node?.position?.y ? parseFloat(node.position.y) : 0,
            },
            data: {
              label: `${node.dag}`,
              isActiveFile: checkActiveFile(node.dag),
              nodeData: {
                logo: node.logo,
                type: node.type,
                ...DAGList.find((target) => target.id === node.dag),
                ...(statusesList && statusesList[node.dag]),
              },
              _setIsShowingDagHistoryTable: undefined,
              _handleDelete: undefined,
            },
          });
          return {
            id: node.dag,
            type: "workflowDAG",
            position: {
              x: node?.position?.x ? parseFloat(node.position.x) : 0,
              y: node?.position?.y ? parseFloat(node.position.y) : 0,
            },
            data: {
              label: `${node.dag}`,
              isActiveFile: checkActiveFile(node.dag),
              logo: node.logo,
              nodeData: {
                logo: node.logo,
                type: node.type,
                ...DAGList.find((target) => target.id === node.dag),
                ...(statusesList && statusesList[node.dag]),
              },
              _setIsShowingDagHistoryTable: undefined,
              _handleDelete: undefined,
            },
          };
        }
      );
      setNodes((nds) => nds.concat(starterData));
      setEdges((edges) => edges.concat(starterEdges));
    }
  };

  const updateOpenedFilesNodes = () => {
    setNodes(
      nodes.map((item) => {
        return {
          ...item,
          data: {
            ...item.data,
            isActiveFile: checkActiveFile(item.data.label),
          },
        };
      })
    );
  };

  useEffect(() => {
    getInitialNodes();
  }, []);

  useEffect(() => {
    if (!init) {
      updateOpenedFilesNodes();
    }
    setInit(false);
  }, [activeFile]);

  return (
    <>
      <section id="workflowManager" className="Lineage-Vis" style={{height: "calc(100% - 40px)", ...style}}>
        <ReactFlowProvider>
          <div style={{ height: "100%" }}>
            {Boolean(nodes.length) ? (
              <div className="dndflow canvas-wrapper canvas-wrapper--full-width" style={{height: "100%"}}>
                <div className="reactflow-wrapper" ref={reactFlowWrapper}>
                  <ReactFlow
                    deleteKeyCode="192"
                    onNodesChange={onNodesChange}
                    nodes={nodes}
                    edges={edges}
                    onInit={setReactFlowInstance}
                    nodeTypes={nodeTypes}
                    minZoom={0.05}
                    maxZoom={0.8}
                    fitView
                  >
                    <Controls />
                  </ReactFlow>
                </div>
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center" style={{height: "100%"}}>
                <p className="text-muted mb-0">No nodes to display</p>
              </div>
            )}
          </div>
        </ReactFlowProvider>
      </section>
    </>
  );
}
